import * as React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { IconButton } from '@mui/material';
import {
    useDataProvider,
    useNotify,
    useRecordContext,
    useTranslate,
} from 'react-admin';
import { StatsTooltip } from '../../components/statistics/common';
import {
    downloadCampaignWorkbook,
    type CampaignWorkbookRecord,
} from './campaignWorkbook';

const CampaignWorkbookButton = () => {
    const record = useRecordContext<{ guid: string }>();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const translate = useTranslate();
    const [exporting, setExporting] = React.useState(false);
    const label = translate('resources.campaign.actions.export_workbook');

    const download = async (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        if (!record?.guid || exporting) return;
        setExporting(true);
        try {
            const { data } = await dataProvider.getOne<CampaignWorkbookRecord>(
                'campaign', { id: record.guid }
            );
            await downloadCampaignWorkbook(data);
        } catch (error) {
            console.error(error);
            notify('resources.campaign.workbook_error', { type: 'error' });
        } finally {
            setExporting(false);
        }
    };

    return (
        <StatsTooltip title={label} followCursor placement="top-start">
            <span>
                <IconButton
                    aria-label={label}
                    color="primary"
                    onClick={download}
                    disabled={!record?.guid || exporting}
                >
                    <DownloadIcon />
                </IconButton>
            </span>
        </StatsTooltip>
    );
};

export default CampaignWorkbookButton;
